import React from "react";
import styled from "styled-components";

import { ITalk } from "../../interfaces";
import List from "../molecules/List";
import Talk from "../molecules/Talk";

interface IProps {
  talks: ITalk[];
}

const TalkList: React.FC<IProps> = ({ talks }) => {
  return (
    <CustomList
      items={talks.map<React.ReactElement<HTMLLIElement>>(talk => (
        <Talk talk={talk} />
      ))}
      inOrder={false}
      style={{ listStyle: "none" }}
    />
  );
};

export default TalkList;

const CustomList = styled(List)`
  & > li {
    display: flex;
    padding: 8px 16px;
    cursor: pointer;
    align-items: center;
  }
`;
